module.exports = __webpack_public_path__ + "static/media/add-picture.9d3a0c0e.svg";